import { Directive, effect, ElementRef, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormTrackerService } from '@unity/services/form-tracker.service';

@Directive({
  // We want this to apply to all forms, not just decorated ones, so we don't apply a prefix
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'form[formGroup]',
  standalone: true,
})
export class TrackFormDirective {
  private readonly formTrackerService = inject(FormTrackerService);

  private readonly elementRef = inject(ElementRef<HTMLFormElement>);

  public readonly $formGroup = input.required<FormGroup>({ alias: 'formGroup' });

  public constructor() {
    effect(() => {
      const form = this.$formGroup();
      this.formTrackerService.registerForm(this.elementRef, form);
    });
  }
}
